import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["progressBar", "successMessage", "progressContainer", "readingForExport"];

  connect() {
    this.startAnimation();
  }

  startAnimation() {
    const progressBar = this.progressBarTarget;
    progressBar.style.transition = "width 3s ease-in-out";
    progressBar.style.width = "100%";
    progressBar.setAttribute('aria-valuenow', 100);

    progressBar.addEventListener('transitionend', () => {
      this.progressContainerTarget.classList.add("d-none");
      this.readingForExportTarget.classList.add("d-none");

      if (this.successMessageTarget.classList.contains("d-none")) {
        this.successMessageTarget.classList.remove("d-none");
      }
    });
  }
}